import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseApiWithAuth } from "@/utilities/reduxToolkit";

export const stepsApi = createApi({
  ...createBaseApiWithAuth({
    reducerPath: "stepsApi",
    baseUrl: "/api/steps",
  }),
  reducerPath: "stepsApi",
  endpoints: (builder) => ({
    createStepEvent: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/${id}/events`,
        method: "POST",
        body: data,
      }),
    }),
    createStepDocument: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/${id}/documents${
          data.documentTemplateId
            ? `?documentTemplateId=${data.documentTemplateId}`
            : ""
        }`,
        method: "POST",
        body: data,
      }),
    }),
    createStepPdfDocument: builder.mutation<
      any,
      { id: string; file: File; data: Record<string, string> }
    >({
      query: ({ id, file, data }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("stepId", id);

        // Append all document metadata as form fields
        Object.entries(data).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            formData.append(key, value);
          }
        });

        return {
          url: `/${id}/documents`,
          method: "POST",
          body: formData,
        };
      },
    }),
    deleteStepDocument: builder.mutation<
      any,
      { stepId: string; documentId: string }
    >({
      query: ({ stepId, documentId }) => ({
        url: `/${stepId}/documents/${documentId}`,
        method: "DELETE",
      }),
    }),
    deleteStepEvent: builder.mutation<any, { stepId: string; eventId: string }>(
      {
        query: ({ stepId, eventId }) => ({
          url: `/${stepId}/events/${eventId}`,
          method: "DELETE",
        }),
      }
    ),
    reorderStepItems: builder.mutation<
      any,
      { stepId: string; items: { id: string; type: "document" | "event"; order: number }[] }
    >({
      query: ({ stepId, items }) => ({
        url: `/${stepId}/reorder`,
        method: "PATCH",
        body: { items },
      }),
    }),
    /** Promote a suggested step_document → live (flips suggested=false). */
    promoteStepDocument: builder.mutation<
      any,
      { stepId: string; documentId: string }
    >({
      query: ({ stepId, documentId }) => ({
        url: `/${stepId}/documents/${documentId}/promote`,
        method: "POST",
      }),
    }),
    /** Promote a suggested step_event → live (flips suggested=false). */
    promoteStepEvent: builder.mutation<
      any,
      { stepId: string; eventId: string }
    >({
      query: ({ stepId, eventId }) => ({
        url: `/${stepId}/events/${eventId}/promote`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useCreateStepEventMutation,
  useCreateStepDocumentMutation,
  useCreateStepPdfDocumentMutation,
  useDeleteStepDocumentMutation,
  useDeleteStepEventMutation,
  useReorderStepItemsMutation,
  usePromoteStepDocumentMutation,
  usePromoteStepEventMutation,
} = stepsApi;
